import React from 'react';
import { ICaretButton } from '../../../interfaces/buttons/buttons';
import BasicButton from './BasicButton';
import { IconLibrary } from '../../../interfaces/icon/IconLibrary';
import Icon from '../icons/Icon';


const CaretButton = ({ content, ariaLabel, className, isDisabled = false, onButtonClick, isLink, linkUrl, openInNewTab = false}: ICaretButton) => {
    const caretButtonContent = 
        <span className='caret-button-content'>
            {content}

            <Icon 
                className='caret-button-icon'
                iconName={IconLibrary.CHEVRON_RIGHT}
                color={"var(--thriveCharcoal"}
                sizeInPx='10'
            />
        </span>
    
    return (
        <BasicButton
            content={caretButtonContent}
            ariaLabel={ariaLabel}
            className={`${className} basic-caret-button`}
            isDisabled={isDisabled}
            onButtonClick={onButtonClick}
            isLink={isLink}
            linkUrl={linkUrl}
            openInNewTab={openInNewTab}
        />
    )
};

export default CaretButton